import { useCallback } from 'react';

import { revalidateArticle } from '@api/notes';
import { useUiNotifications } from '@components/notifications/ui-notification-boundary';

/**
 * Revalidate the article and home page.
 *
 * @param articleSlug The setter method for the state.
 * @return revalidateArticle Hook that can be used as callback for article update on website.
 */
export const useRevalidateArticle = (articleSlugs: string[]) => {
  const { dispatchUiNotification } = useUiNotifications();

  const revalidateArticleCallback = useCallback(() => {
    const revalidateArticlePromise = articleSlugs.map((slug) =>
      revalidateArticle(slug)
    );
    Promise.all(revalidateArticlePromise).then((res) => {
      res.forEach((success, index) => {
        let revalidateTarget = articleSlugs[index];
        revalidateTarget =
          revalidateTarget === '' ? 'Home Page' : revalidateTarget;
        dispatchUiNotification(
          'Article Revalidation Status',
          `Revalidation of ${revalidateTarget} ${
            success ? 'successful' : 'failed'
          }.`,
          {}
        );
      });
    });
  }, [...articleSlugs]);

  return {
    revalidateArticleCallback
  };
};
